import React, { useContext } from 'react'
import FilterSelect from "../../components/Filter/FilterSelect"
import FilterSearch from "../../components/Filter/FilterSearch"
import _ from 'lodash'
import { FormattedMessage, useIntl } from 'react-intl'
import { ORDER_DESCENDING, ROLES, ROLES_ARR, SORT_ORDERS, IS_ACTIVE, CONTENT_TYPE } from '../../constants'
import SelectAPIField from '../../components/Filter/FilterSelectAPI'

const Filters = ({ filters, setFilters, applyFilters, resetFilters, appliedFilters }) => {
    const intl = useIntl();

    const setFilterState = (value, field) => {
        setFilters(old => {
            const copy = _.cloneDeep(old);
            copy[field] = value
            return copy
        })
    }
    const handleSearchKeyDown = (event) => {
        if (event.key === 'Enter') {
            applyFilters();
        }
    };

    return (
        <div className=''>
            <div className='container grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5 gap-x-5 gap-y-3'>

                <div onKeyDown={handleSearchKeyDown}>
                <FilterSearch
                    placeholder={intl?.formatMessage({ id: "search", defaultMessage: "Search" })}
                    label_text={intl?.formatMessage({ id: "search", defaultMessage: "Search" })}
                    setState={(value) => setFilterState(value, "search")}
                    state={filters.search}

                />
                </div>
             
                {/* <SelectAPIField
                    isClearable={true}
                    state={filters.department}
                    setState={(value) => setFilterState(value, "department")}
                    label_text="Department"
                    placeholder="Department"
                    url="api/department"
                    valueGenerator={val => ({ label: val.name ? val.name : "-", value: val })}
                /> */}
                <FilterSelect
                    placeholder={intl?.formatMessage({ id: "all", defaultMessage: "All" })}
                    label_text={intl?.formatMessage({ id: "content", defaultMessage: "Content" })}
                    options={CONTENT_TYPE}
                    setState={(value) => setFilterState(value, "content")}
                    state={filters.content}
                />
                {/* <FilterSelect
                    disableClearable={true}
                    placeholder={intl.formatMessage({ id: "order_by", defaultMessage: "Order By" })}
                    label_text={intl.formatMessage({ id: "order_by", defaultMessage: "Order By" })}
                    options={SORT_ORDERS}
                    setState={(value) => setFilterState(value, "sort_order")}
                    state={filters.sort_order}
                /> */}

                <div className="flex items-end z-0">
                    <button
                        disabled={!(appliedFilters.search || appliedFilters.content )}
                        onClick={resetFilters}
                        type="button"
                        className={`w-full col-span-2 btn !py-2 !px-4 h-[42px] !text-sm btn-secondary z-0`}
                    >
                        
                            <FormattedMessage id="reset_filters" defaultMessage={"Reset Filters"} />
                        
                    </button>
                </div>
                <div className="flex items-end">
                    <button
                        disabled={
                            filters.search.trim() === appliedFilters.search.trim()
                                &&
                                filters.content?.value === appliedFilters.content?.value
                                
                                ?
                                true
                                :
                                false
                        }
                        onClick={applyFilters}
                        type="button"
                        className='w-full col-span-2 btn !py-2 !px-4 h-[42px] !text-sm btn-primary'
                    >
                        <p className='relative'>
                            <FormattedMessage id="apply_filters" defaultMessage={"Apply Filters"} />
                        </p>
                    </button>
                </div>
            </div>

        </div>
    )
}

export default Filters